// extracted by mini-css-extract-plugin
module.exports = {"normal":"UploadFileBox_normal__1qV_N"};